/**
 * Updates [data-tire-install-estimate] when tire size / variant changes on PDP.
 */
(function () {
  function extractRimDiameter(size) {
    if (!size) return "";
    var m = String(size).match(/R([\d.]+)\s*$/i);
    if (!m) return "";
    return m[1].replace(/\.0$/, "");
  }

  function resolveMount(rim, mountByRim, fallback) {
    if (rim && mountByRim && mountByRim[rim] != null) {
      var n = Number(mountByRim[rim]);
      if (Number.isFinite(n) && n >= 0) return n;
    }
    return Number(fallback) || 0;
  }

  function formatMoney(n) {
    return "$" + (Math.round(n * 100) / 100).toFixed(2);
  }

  function updateInstallEstimate(root, tireSize, tireUnitCents, qty) {
    if (!root) return;
    var configEl = document.getElementById("tire-install-fee-config");
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var q = qty != null ? Number(qty) : Number(config.defaultQty) || 4;
    if (!Number.isFinite(q) || q < 1) q = 4;

    var rim = extractRimDiameter(tireSize);
    var mount = resolveMount(rim, config.mountByRim, config.mountFallback);
    var disposal = Number(config.disposal) || 0;

    var tireSubtotal = 0;
    if (tireUnitCents != null && tireUnitCents > 0) {
      tireSubtotal = (Number(tireUnitCents) * q) / 100;
    }

    var installSubtotal = mount + disposal;
    var estimatedTotal = tireSubtotal + installSubtotal;

    var mountLabel = root.querySelector("[data-install-label=\"mount\"]");
    if (mountLabel) {
      mountLabel.textContent = rim
        ? "Mount & balance (" + rim + '")'
        : "Mount & balance";
    }

    var mountRow = root.querySelector("[data-install-row=\"mount\"]");
    if (mountRow) mountRow.textContent = formatMoney(mount);

    var totalRow = root.querySelector("[data-install-row=\"total\"]");
    if (totalRow) {
      totalRow.textContent = formatMoney(
        tireSubtotal > 0 ? estimatedTotal : installSubtotal
      );
    }

    if (rim) root.setAttribute("data-rim-diameter", rim);
    else root.removeAttribute("data-rim-diameter");
  }

  window.SpecrTireInstallEstimate = {
    extractRimDiameter: extractRimDiameter,
    resolveMount: resolveMount,
    updateInstallEstimate: updateInstallEstimate,
  };
})();
